import React from 'react'
import { required, SelectInput } from 'react-admin'
import { drinkSpecialTypeChoices } from 'services/cfg/form'
import ProductSectionForm, {
  ProductSectionFormProps,
} from 'ui-shared/Forms/ProductSectionForm'

type DrinkSectionFormProps = Omit<ProductSectionFormProps, 'entity'>

const DrinkSectionForm: React.FC<DrinkSectionFormProps> = (props) => (
  <ProductSectionForm
    {...props}
    canAssignProductToMultipleSections={false}
    entity="drinks"
  >
    <SelectInput
      source="specialType"
      choices={drinkSpecialTypeChoices}
      validate={required()}
    />
  </ProductSectionForm>
)

export default DrinkSectionForm
